module.exports = {"api":"https://dapnet.es/api","update":"https://www.hampager.de/dapnet-update/update.php","hamnetDb":"https://www.hampager.de/dapnet-update/callsignLocation.php","map":"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png","news":"https://hampager.de/dokuwiki/feed.php?ns=blog"}


//////////////////
// WEBPACK FOOTER
// ./src/store/config/defaultUrls.json
// module id = m0WH
// module chunks = 1